import { ActionConfig, ActionContext } from '../../../logic/types'
import { WithdrawFromWethAction } from '../types'
import { wethAbi, wethAddress } from '@/config/contracts-generated'
import { getContractAddress } from '@/domain/hooks/useContractAddress'
import { getBalancesQueryKeyPrefix } from '@/domain/wallet/getBalancesQueryKeyPrefix'
import { ensureConfigTypes } from '@/features/actions/logic/transactions/useWrite'

export function createWithdrawFromWethActionConfig(
  action: WithdrawFromWethAction,
  context: ActionContext,
): ActionConfig {
  const { account, chainId } = context

  return {
    getWriteConfig: () => {
      const amount = action.eth.toBigInt(action.amount)

      return ensureConfigTypes({
        abi: wethAbi,
        address: getContractAddress(wethAddress, chainId),
        functionName: 'withdraw',
        args: [amount],
      })
    },

    invalidates: () => [getBalancesQueryKeyPrefix({ chainId, account })],
  }
}
